import React from 'react';
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { OrderInfo } from 'common/types';
import { useTranslation } from 'services/localization/useTranslation';
import classNames from 'classnames';
import { getOrderPayments } from 'common/modules/atoms/paymentAmounts';

interface Props {
	rentalInfo: OrderInfo;
}
const RentalCardPaymentStatus = (props: Props) => {
	const { rentalInfo } = props;
	const classes = useStyles();
	const { t } = useTranslation();
	const chargePayment = getOrderPayments(rentalInfo).charge;
	const unpaidAmount = chargePayment.unpaid;

	return (
		<div className={classNames(classes.statusDiv, classes.paymentStatus)}>
			<div
				className={
					unpaidAmount > 0
						? classNames(classes.circle, classes.unpaidColor)
						: classNames(classes.circle, classes.paidColor)
				}
			></div>
			<Typography variant={'body2'}>
				{unpaidAmount > 0 ? t('common:payment.unpaid') : t('common:payment.paid')}
			</Typography>
		</div>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		statusDiv: {
			padding: theme.spacing(1),
			alignItems: 'center',
			display: 'flex',
		},
		paymentStatus: {
			backgroundColor: theme.palette.background.secondary,
			minWidth: 82,
			marginLeft: theme.spacing(1.25),
		},
		circle: {
			width: 13,
			border: 'solid 1px',
			height: 13,
			borderRadius: '50%',
			marginRight: theme.spacing(1),
		},
		paidColor: {
			backgroundColor: theme.palette.success.main,
			borderColor: theme.palette.success.main,
		},
		unpaidColor: {
			backgroundColor: theme.palette.error.main,
			borderColor: theme.palette.error.main,
		},
	}),
);

export default RentalCardPaymentStatus;
